/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import styled from 'styled-components';
import { Popover } from 'antd';

export const StyledUser = styled.div`
  flex: none;
  .header-user-link {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    display: inline-block;
    cursor: pointer;
    &:hover {
      color: #fff;
    }
  }

  &-avatar {
    height: 28px;
    width: 28px;
    cursor: pointer;
  }

  .cutting-line {
    color: rgba(255, 255, 255, 0.7);
    margin: 0 5px;
  }
`;

export const StyledPopover = styled(Popover)`
  .ant-popover-inner-content {
    padding: 10px 7px 0;

    .header-user-popover {
      font-size: 14px;
      min-width: 100px;

      p[data-field='username'] {
        padding: 0 5px;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        img {
          width: 14px;
          height: 14px;
        }
        span {
          color: #333;
          cursor: pointer;
          margin-right: 5px;
        }
      }

      p[data-field='company'] {
        color: #666;
        font-size: 12px;
        padding: 0 5px 5px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      }

      ul {
        list-style: none;
        li {
          /* &:first-child {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          } */
        }
        li > span {
          padding: 0 7px;
          line-height: 30px;
          color: #333;
          display: block;
          cursor: pointer;
          &:hover {
            color: #1283d5;
          }
        }
      }
    }
  }
`;
